import { useEffect } from "react";
import { useLocation, Redirect } from "react-router-dom";
import qs from "query-string";
import { Sentry } from "@nested/isomorphic-sentry";
import { useSelector } from "react-redux";

/**
 * The CalendlyOnboarding question ends with a redirect containing all the data entered
 * in Calendly, which is extracted from the query parameters here and then saved to
 * the backend
 */

export const CalendlyCallback = ({ next, submitError, updateFormState }) => {
  const location = useLocation();
  const params = qs.parse(location.search);
  const formState = useSelector((state) => state.onboardingForm);

  useEffect(() => {
    updateFormState({
      agentFullName: params.assigned_to,
      bookingDate: params.event_start_time,
      email: {
        email: params.invitee_email,
        privacyPolicyConsent: formState.contactDetails
          ? formState.contactDetails?.privacyPolicyConsent
          : formState.email?.privacyPolicyConsent,
      },
      name: {
        firstName: params.invitee_first_name,
        lastName: params.invitee_last_name,
      },
      phone: params.answer_1,
    });
    next(true);
  }, []);

  if (submitError) {
    Sentry.captureMessage(
      "[CalendlyCallback] Failed to submit Calendly callback",
      {
        extra: {
          params,
        },
      },
    );
    return <Redirect to="/get-started" />;
  }

  return null;
};
